import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=04122f6c"
import script from "./Tv.vue?vue&type=script&lang=js"
export * from "./Tv.vue?vue&type=script&lang=js"
import style0 from "./Tv.vue?vue&type=style&index=0&id=04122f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports